jQuery(document).ready(function($) {
    
    // Homepage Pause/play video functionality
    //----------------------------------------------
    
    var heroVideo = document.getElementById('siteHomeVideo');
    
    // Only do these actions if the video exists.
    if (heroVideo) {
        
        // Grab the pause button and its icon.
        var videoPauseButton = document.getElementById('videoPauseBtn'),
            videoPauseIcon = document.getElementById('videoPauseBtnIcon');
        
        // Display the pause/play button if the video is playing.
        // This ensures we're not showing a useless button if the 
        // video doesn't load or the files aren't found.
        heroVideo.onplaying = function() {
            videoPauseButton.classList.remove('invisible');
        };
        
        // Set up the pause and play reusable functions.
        function playVideo() {
            // Play the video
            heroVideo.play();
            // Update the button icon to 'Pause'
            videoPauseIcon.classList.remove('fa-play-circle');
            videoPauseIcon.classList.add('fa-pause-circle');
        }
        
        function pauseVideo() {
            // Pause the video
            heroVideo.pause();
            // Update the button text to 'Play'
            videoPauseIcon.classList.remove('fa-pause-circle');
            videoPauseIcon.classList.add('fa-play-circle');
        }
        
        // Grab the prefers reduced media query.
        const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

        // Check if the media query matches.
        if (mediaQuery.matches) {
            // User prefers reduced motion, so we don't play the video.
            pauseVideo();
            // Display the play button so the user can play video if they want.
            // It has been hidden by default in case the video doesn't load.
            videoPauseButton.classList.remove('invisible');
        } else {
            // User has no preference or the query isn't supported.
            playVideo();
        }

        // Adds an event listener to check for changes in the media query's value.
        mediaQuery.addEventListener('change', () => {
            if (mediaQuery.matches) {
                // User prefers reduced motion, so we don't play the video.
                pauseVideo();
                // Display the play button so the user can play video if they want.
                // It has been hidden by default in case the video doesn't load.
                videoPauseButton.classList.remove('invisible');
            } else {
                // User has no preference or the query isn't supported.
                playVideo();
            }
        });
        
        // Set up event listener for the video play/pause button if it exists.
        if (videoPauseButton) {
            videoPauseButton.addEventListener('click', function() {
                if (heroVideo.paused == true) {
                    playVideo();
                } else {
                    pauseVideo();
                }
            });
        }
    }
});
